export default [
  {
    name: 'preciseStatistics',
    path: 'preciseStatistics',
    component: () => import(/* webpackChunkName: 'configStatistics' */ '@/views/configStatistics/preciseStatistics/index.vue'),
    meta: { keepAlive: true },
  },
  {
    name: 'qaConfig',
    path: 'qaConfig',
    component: () => import(/* webpackChunkName: 'configStatistics' */ '@/views/configStatistics/qaConfig/index.vue'),
    meta: { keepAlive: true },
  },
  {
    name: 'qaStatistics',
    path: 'qaStatistics',
    component: () => import(/* webpackChunkName: 'configStatistics' */ '@/views/configStatistics/qaStatistics/index.vue'),
    meta: { keepAlive: true },
  },
  {
    name: 'statisticalData',
    path: 'statisticalData',
    component: () => import(/* webpackChunkName: 'statisticalData' */ '@/views/configStatistics/statisticalData/index.vue'),
    meta: { keepAlive: true },
  },
  {
    name: 'platformBoard',
    path: 'platformBoard',
    component: () => import(/* webpackChunkName: 'platformBoard' */ '@/views/configStatistics/platformBoard/index.vue'),
    meta: { keepAlive: true },
  },
];
